import React from 'react';
import WorkingDay from 'components/Tvendo/WorkingDay/List';

export default function () {
  return <WorkingDay />;
}
